import type { Theme } from './types'
import { params, state } from './state'
import { translations } from './i18n'

const THEME_KEY = 'been-web:theme'

export function loadTheme(): Theme {
  const requested = params.get('theme')
  if (requested === 'light' || requested === 'dark') return requested
  const stored = localStorage.getItem(THEME_KEY)
  if (stored === 'light' || stored === 'dark') return stored
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}

export function setTheme(theme: Theme): void {
  state.theme = theme
  localStorage.setItem(THEME_KEY, theme)
}

/**
 * Sync the current theme + language onto the root element.
 * Does NOT call applyTranslations — callers decide whether the DOM text
 * needs refreshing too (theme changes don't, language changes do).
 */
export function applyPreferences(): void {
  document.documentElement.dataset.theme = state.theme
  // document.documentElement.lang = translations[state.lang].htmlLang
}
